import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const CategoriesContext = createContext(null);

export const CategoriesProvider = ({ children }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/config/categories");
      if (!Array.isArray(data.categories) || !data.categories.length) throw new Error("No categories available");
      setCategories(data.categories); setError("");
    } catch { setError("Could not load cubing categories. Please try again."); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { reload(); }, [reload]);
  const value = useMemo(() => ({ categories, loading, error, reload,
    ALL_CATEGORIES: categories.map((category) => category.value),
    CATEGORY_LABEL: Object.fromEntries(categories.map((category) => [category.value, category.label])),
  }), [categories, loading, error, reload]);
  return <CategoriesContext.Provider value={value}>{children}</CategoriesContext.Provider>;
};

export const useCategories = () => {
  const value = useContext(CategoriesContext);
  if (!value) throw new Error("useCategories requires CategoriesProvider");
  return value;
};
